import TopicAPI from '@/apis/business/common/topic-api.js'
import TopicTeacherAPI from '@/apis/business/teacher/topic-api.js'

export default {
  namespaced: true,

  state: {
    listTopicResult: {}
  },

  getters: {},

  mutations: {
    /**
     * @description set dữ liệu cho state classrooms
     * @author NTQyy
     * @param {*} state
     * @param {*} classRooms
     */
    setTopics (state, topics) {
      state.listTopicResult = topics
    }
  },

  actions: {
    /**
     * @author PVThang
     * @param {*} context
     * @param {object} params GradeID - ID khối; SubjectCode - Mã môn học
     * @description Lấy danh sách Topic
     */
    getTopics (context, query) {
      return TopicAPI.getAsync(`filter/grade-subject?${query}`)
    },

    /**
     * @author PVThang
     * @param {*} context
     * @param {object} params GradeID - ID khối; SubjectCode - Mã môn học
     * @description Lấy danh sách Topic
     */
    getListTopicOverview (context, param) {
      const query =
      `classCode=${param.ClassCode ? param.ClassCode : ''}` +
      `&type=${param.Type}` +
      `&subjectCode=${param.SubjectCode ? param.SubjectCode : ''}` +
      `&sortType=${param.SortType}` +
      `&skip=${param.Skip}` +
      `&take=${param.Take}` +
      `&takeAll=${param.takeAll ? param.takeAll : ''}`
      return new Promise((resolve, reject) => {
        TopicTeacherAPI.getAsync(`overview?${query}`).then(res => {
          context.commit('setTopics', res.Data)
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}
